import { IInvoiceRespSchema, InvoiceDisplayProps } from '@monetize/types/app';
import { TAX_ERROR_CAN_RESOLVE_STATUSES } from '../../constants/invoice';
import { PAPER_PAGE_MAX_WIDTH } from '../../constants/quotes';
import { MBox, MFlex, MPageLoader } from '../Monetize';
import MEmptyDataPlaceholder from '../Monetize/MEmptyDataPlaceholder';
import { InvoiceHtml } from './InvoiceHtml';
import { InvoiceHtmlPublic } from './InvoiceHtmlPublic';
import { InvoiceTaxCalculationError } from './InvoiceTaxCalculationError';

const InvoiceDisplay = ({
  invoice,
  loadingInvoice,
  invoiceSettings,
  isInReview,
  canPayInvoice,
  isInvoiceSharePage,
  unpaidInvoices,
  onPayInvoice,
  companyLogoData,
  handleOpenEditContactModal,
  tenantId,
  invoiceSecretId,
}: InvoiceDisplayProps & {
  invoice?: IInvoiceRespSchema | null;
  handleOpenEditContactModal?: () => void;
}) => {
  if (loadingInvoice) {
    return <MPageLoader />;
  }

  if (!invoice && isInReview) {
    return (
      <MFlex justifyContent="center">
        <MEmptyDataPlaceholder
          mainMessage="No Invoice To Preview"
          smallMessage="The changes you have made don't result in an invoice, click save to continue with your changes."
        />
      </MFlex>
    );
  }
  if (!invoice) {
    return (
      <MFlex justifyContent="center">
        <MEmptyDataPlaceholder mainMessage="No Invoice To Preview" />
      </MFlex>
    );
  }

  return (
    <MBox maxW={PAPER_PAGE_MAX_WIDTH} w="full" pt="3">
      {/* Never show tax calculation error to end-user */}
      {!isInvoiceSharePage && (
        <InvoiceTaxCalculationError
          taxError={invoice.taxError}
          showReviewAction={TAX_ERROR_CAN_RESOLVE_STATUSES.has(invoice.status)}
          onOpenEditContactModal={handleOpenEditContactModal}
        />
      )}

      <MBox
        bgColor="bg.subtle"
        borderWidth="1px"
        borderStyle="solid"
        borderColor="border.subtle"
        borderRadius="lg"
      >
        {!isInvoiceSharePage ? (
          <InvoiceHtml invoice={invoice} />
        ) : (
          <InvoiceHtmlPublic
            invoice={invoice}
            tenantId={tenantId}
            invoiceSecretId={invoiceSecretId}
          />
        )}
      </MBox>
    </MBox>
  );
};

export default InvoiceDisplay;
